module.exports = __webpack_public_path__ + "static/media/Southwyck-HOA.374d7281.pdf";